module.exports = __webpack_public_path__ + "static/media/spectators-default.3376d1ed.gif";